import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  member: {
    display: 'flex',
    alignItems: 'center',
    padding: '18px 24px',
    '& + &': {
      borderTop: "1px solid ".concat(palette.shades[300])
    }
  },
  role: {
    width: '220px',
    marginRight: '24px'
  },
  contact: {
    width: '160px',
    marginRight: '24px'
  },
  emailWrapper: {
    flexGrow: '1',
    flexShrink: '0',
    width: '220px',
    marginRight: '24px',
    [breakpointsFunc.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  email: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginLeft: '10px',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [breakpointsFunc.breakpoints.down('md')]: {
      marginTop: '10px',
      marginLeft: '0'
    }
  },
  actionButton: {
    [breakpointsFunc.breakpoints.down('md')]: {
      '& + &': {
        marginTop: '10px'
      }
    }
  }
});
export default useStyles;